import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Form, Select } from 'antd'
import FormalityStepButton from '../FormalityStepButton'
import { FormInstance } from 'antd/es/form'

interface IProps {
  form: FormInstance
  onFinish: any
  loading?: boolean
}

const FormCompletionConfirm = (props: IProps) => {
  const { t } = useTranslation('legalFormalities')
  const { form, onFinish, loading = false } = props
  const [formValid, setFormValid] = useState<boolean>(true)

  const validateFormFields = async () => {
    form
      .validateFields()
      .then(() => setFormValid(true))
      .catch(() => setFormValid(false))
  }

  const formItems = () => {
    return (
      <>
        {t('show.form.completion.title')}
        <Form.Item
          name="depositProvider"
          label={t('show.form.completion.label')}
          initialValue={null}
          rules={[]}
        >
          <Select
            onChange={() => validateFormFields()}
            dropdownStyle={{ zIndex: 10000 }}
          >
            <Select.Option value={null}>
              {t('show.form.completion.options.manuel')}
            </Select.Option>
            <Select.Option value="guichet_unique">
              {t('show.form.completion.options.guichet_unique')}
            </Select.Option>
          </Select>
        </Form.Item>
      </>
    )
  }

  return (
    <>
      <FormalityStepButton
        title={t('show.form.submit.confirm.next.title')}
        description={formItems()}
        buttonDisabled={loading}
        buttonLabel={t('show.form.submit.confirm.next.label')}
        onConfirm={() => onFinish(form.getFieldsValue())}
        okConfirmDisabled={!formValid}
      />
    </>
  )
}

export default FormCompletionConfirm
